// Filtros para búsqueda
export interface Filters {
  searchTerm?: string;
  productId?: number;
  typeId?: number;
  teamId?: number; // 🆕 Filtrar por equipo
  // 🎯 Campos específicos procesados desde filterConditions
  type_ids?: number[]; // Para múltiples tipos
  product_ids?: number[]; // Para múltiples productos
  // 🎯 Campos para sorting
  sortBy?: string; // Campo por el que ordenar
  sortDirection?: 'asc' | 'desc'; // Dirección del ordenamiento
  page?: number;
  limit?: number;
  event_ids?: number[];
}

export interface ProductsWithoutStockModel {
  shop_id: number;
  payment_method_id: number;
  product_id: number;
  team_id: number;
  total_quantity: number;
  available_stock: number;
  stock_deficit: number;
  has_stock_problem: boolean;
  product_name: string;
  product_code: string;
  product_image_url: string;
  shop_name: string;
  payment_method_name: string;
  orders: OrderInfo[];
}

export interface OrderInfo {
  id: number;
  ref: string;
  shop_id: number;
  payment_method_id: number;
  shop_name: string;
  shop_image_hash: string;
  lines: OrderLine[];
}

export interface OrderPack {
  id: number;
  title: string;
}

export interface OrderLine {
  id: number;
  qty: number;
  product: {
    id: number;
    name: string;
    code: string;
    image_hash: string;
  } | null;
  pack: OrderPack | null;
}

/** Entrada de pedido para la modal (solo identificación, sin líneas). */
export interface OrdersModalListEntry {
  orderId: number;
  ref: string;
}

export function mapOrdersToModalList(orders: OrderInfo[] | undefined): OrdersModalListEntry[] {
  return (orders ?? []).map((order) => ({
    orderId: order.id,
    ref: order.ref,
  }));
}

export interface ProductsWithoutStockSummary {
  total_products: number;
  total_required_quantity: number;
  total_available_stock: number;
  total_deficit: number;
  total_orders_affected: number;
}

// Interfaces para cálculos de la tabla
export interface ProductTableRow {
  producto: {
    id: number;
    name: string;
    code: string;
    image_hash: string;
  };
  requerido: number;
  disponible: number;
  deficit: number;
  pedido: number;
}
